module.exports = __webpack_public_path__ + "assets/img/usp-1.cd994069.svg";